<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >{{hdrText}} компонента </v-toolbar>
      <project-component-card :comp="localComp" :mode="'editor'" @onCompUpdate="doCompUpdate"/>
      <v-card-actions>
        <v-btn class="secondary" @click="doClose">
          Закрыть
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark :disabled="saveDisabled" @click="doSave" outlined>
          {{btnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import axios from 'axios'
import { UI_SNACKBAR } from '@/store/actions/ui'
import ProjectComponentCard from '@/components/modules/projects/cards/configuration/projectComponentCard'
export default {
  name: 'prjAddProjectComponentDialog',
  components: { ProjectComponentCard },
  props: ['comp', 'project', 'value'],
  data () {
    return {
      localComp: null
    }
  },
  computed: {
    btnText: {
      get () {
        return this.localComp ? this.dataNew ? 'Добавить' : 'Обновить' : ''
      }
    },
    hdrText: {
      get () {
        return this.localComp ? this.dataNew ? 'Добавление' : 'Редактирование' : ''
      }
    },
    saveDisabled: {
      get: function () {
        if (!this.localComp) return true
        const noMin = !this.localComp.COMP_LOWER_LIMIT
        const noMax = !this.localComp.COMP_UPPER_LIMIT
        const noPrice = !this.localComp.COMP_PRICE
        const noStep = !this.localComp.COMP_STEP
        return noMin || noMax || noPrice || noStep || !this.dataChanged
      }
    },
    dataChanged: {
      get () {
        if (this.dataNew) return true
        return this.comp[0].COMP_PRICE !== this.localComp.COMP_PRICE ||
               this.comp[0].COMP_LOWER_LIMIT !== this.localComp.COMP_LOWER_LIMIT ||
               this.comp[0].COMP_UPPER_LIMIT !== this.localComp.COMP_UPPER_LIMIT ||
               this.comp[0].COMP_STEP !== this.localComp.COMP_STEP ||
               this.comp[0].COMP_ID !== this.localComp.COMP_ID
      }
    },
    dataNew: {
      get: function () {
        console.log('Requested for dataNew. Initial property is ', this.comp, '. Local property is ', this.localComp)
        return !this.comp.length
      }
    }
  },
  watch: {
    comp (val) {
      console.log('prjAddProjectComponentDialog watcher comp detected change to ', val)
      if (val && val.length) {
        console.log('val length is more than 0')
        // eslint-disable-next-line no-undef
        this.localComp = structuredClone(this.comp[0])
      } else {
        console.log('val length is 0')
        this.localComp = {}
      }
      console.log('Current lP is ', this.localComp)
    }
  },
  methods: {
    doSave () {
      const self = this
      const action = this.dataNew ? 'add' : 'update'
      const processorPath = action === 'update' ? '/api/org/receptures/rcptUpdComponent.php' : '/api/org/receptures/rcptAddComponent.php'
      const payload = { ...this.localComp }
      payload.COMP_STEP = this.localComp.COMP_STEP || 1
      payload.ULF_ID = this.project.ULF_ID
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              self.$emit('componentAdded', [resp.data.data])
            } else {
              self.$emit('componentUpdate', [resp.data.data])
            }
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doCompUpdate (data) {
      console.log('prjAddProjectComponentDialog:: doCompUpdate method called ', data)
      this.localComp = { ...this.localComp, ...data }
      console.log('prjAddProjectComponentDialog:: doCompUpdate current data is ', this.localComp)
    }
  },
  mounted () {
    console.log('prjAddProjectComponentDialog mounted with property ', this.comp)
  }
}
</script>
